module.exports = __webpack_public_path__ + "img/wechat.70dd5166.svg";